var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.6562 18.6875L19.5 9.84375L18.0625 8.4375L10.6562 15.8438L6.90625 12.0938L5.5 13.5L10.6562 18.6875ZM12.5 25.5C10.7917 25.5 9.17708 25.1719 7.65625 24.5156C6.13542 23.8594 4.80729 22.9635 3.67188 21.8281C2.53646 20.6927 1.64062 19.3646 0.984375 17.8438C0.328125 16.3229 0 14.7083 0 13C0 11.2708 0.328125 9.64583 0.984375 8.125C1.64062 6.60417 2.53646 5.28125 3.67188 4.15625C4.80729 3.03125 6.13542 2.14062 7.65625 1.48438C9.17708 0.828125 10.7917 0.5 12.5 0.5C14.2292 0.5 15.8542 0.828125 17.375 1.48438C18.8958 2.14062 20.2188 3.03125 21.3438 4.15625C22.4688 5.28125 23.3594 6.60417 24.0156 8.125C24.6719 9.64583 25 11.2708 25 13C25 14.7083 24.6719 16.3229 24.0156 17.8438C23.3594 19.3646 22.4688 20.6927 21.3438 21.8281C20.2188 22.9635 18.8958 23.8594 17.375 24.5156C15.8542 25.1719 14.2292 25.5 12.5 25.5ZM12.5 23.625C15.4583 23.625 17.9688 22.5885 20.0312 20.5156C22.0938 18.4427 23.125 15.9375 23.125 13C23.125 10.0417 22.0938 7.53125 20.0312 5.46875C17.9688 3.40625 15.4583 2.375 12.5 2.375C9.5625 2.375 7.05729 3.40625 4.98438 5.46875C2.91146 7.53125 1.875 10.0417 1.875 13C1.875 15.9375 2.91146 18.4427 4.98438 20.5156C7.05729 22.5885 9.5625 23.625 12.5 23.625Z",
    fill: "#3A74F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckCircle);
export default __webpack_public_path__ + "static/media/icon-check-circle.ab7164aaeca5d69bca6cc5d7c2e1729e.svg";
export { ForwardRef as ReactComponent };